import { ChangeDetectionStrategy, Component, computed, Input, signal } from '@angular/core';
import { NgClass, NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'ln-ln-image-frame',
  imports: [NgOptimizedImage, NgClass],
  templateUrl: './ln-image-frame.component.html',
  styleUrl: './ln-image-frame.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnImageFrameComponent {
  @Input({ required: true }) src!: string;
  @Input({ required: true }) alt!: string;
  @Input() class = '';
  @Input() width = '66';
  @Input() height = '41';
  private _loaded = signal(false);
  protected loaded = computed(() => this._loaded());

  protected imageLoaded() {
    this._loaded.set(true);
  }
}
